import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

export type AsistenteGrupo = {
  nombre: string;
  telefono?: string;
};

export type RegistroGrupal = {
  nombre: string;
  tipo: 'EMPRESA' | 'ESCUELA' | 'OTRO';
  contacto_nombre?: string;
  contacto_email?: string;
  evento_id?: number | null;
  asistentes: AsistenteGrupo[];
};

export async function obtenerGrupos() {
  const response = await axios.get(`${API_URL}grupos`);
  return response.data?.doc?.data?.rows || [];
}

export async function registroGrupalService(values: RegistroGrupal) {
  const response = await axios.post(`${API_URL}grupos`, values);
  return response.data?.doc?.data;
}
